
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/_error", function() {
      var page = require("/Users/andym/Development/Active/Website/node_modules/next/dist/pages/_error.js")
      if(module.hot) {
        module.hot.accept("/Users/andym/Development/Active/Website/node_modules/next/dist/pages/_error.js", function() {
          if(!next.router.components["/_error"]) return
          var updatedPage = require("/Users/andym/Development/Active/Website/node_modules/next/dist/pages/_error.js")
          next.router.update("/_error", updatedPage.default || updatedPage)
        })
      }
      return { page: page.default || page }
    }]);
  